import { Check, Copy, MessageCircle, Send } from 'lucide-react';
import { useState } from 'react';
import { Button } from '@/components/ui/Button';
import type { SharePayload } from '@/utils/share';
import { createWhatsAppUrl, createXUrl, shareContent } from '@/utils/share';

type ShareBarProps = {
  payload: SharePayload;
};

export function ShareBar({ payload }: ShareBarProps) {
  const [copied, setCopied] = useState(false);

  async function handleShare() {
    const result = await shareContent(payload);
    setCopied(result === 'copied');
    window.setTimeout(() => setCopied(false), 1800);
  }

  return (
    <div className="flex flex-wrap gap-2">
      <Button icon={copied ? Check : Send} onClick={() => void handleShare()}>
        {copied ? 'Copiado' : 'Compartir'}
      </Button>
      <a
        href={createWhatsAppUrl(payload)}
        target="_blank"
        rel="noreferrer"
        className="inline-flex min-h-10 items-center justify-center gap-2 rounded bg-white/5 px-4 text-sm font-semibold text-white transition hover:bg-white/10"
      >
        <MessageCircle size={18} aria-hidden="true" />
        WhatsApp
      </a>
      <a
        href={createXUrl(payload)}
        target="_blank"
        rel="noreferrer"
        className="inline-flex min-h-10 items-center justify-center gap-2 rounded bg-white/5 px-4 text-sm font-semibold text-white transition hover:bg-white/10"
      >
        <Copy size={18} aria-hidden="true" />X
      </a>
    </div>
  );
}
